// @flow
import React, { Fragment } from 'react';
import * as css from './Progress.module.css';

type PropsType = {
  children?: React.Node,
  progress: int,
  isComviq: boolean,
};

const Progress = ({ children, progress = 1, isComviq }: PropsType) => {
  const empty = {
    height: isComviq ? `100%` : `${100 - progress}%`,
  };
  return (
    <Fragment>
      <div className={css.fill}>{children}</div>
      <div style={empty} className={`${css.empty}`}>
        {children}
      </div>
    </Fragment>
  );
};

export default React.memo(Progress);
